exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".customersOrderTable .custom-table {\n  max-width: 100vw; }\n\n.shopsContainer.customerOrderStatuses {\n  max-height: calc(100vh - 150px);\n  overflow: auto; }\n\n@media only screen and (max-width: 768px) {\n  .searchBoxFilters {\n    -ms-flex-direction: column;\n    flex-direction: column; } }\n\n.mb-first-line {\n  margin-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/CustomersOrders/CustomersOrders.scss
// module id = 1681
// module chunks = 0